"use client";

import { useCallback } from "react";
import { Mic } from "lucide-react";
import { useVoiceInput } from "@/hooks/useVoiceInput";
import { cn } from "@/lib/utils";

type MicButtonProps = {
  onTranscript: (text: string) => void;
  className?: string;
};

export function MicButton({ onTranscript, className }: MicButtonProps) {
  const { isListening, isSupported, toggle } = useVoiceInput();

  const handleClick = useCallback(() => {
    toggle(onTranscript);
  }, [toggle, onTranscript]);

  if (!isSupported) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={isListening ? "Stop dictation" : "Start dictation"}
      className={cn(
        "inline-flex items-center justify-center rounded-md p-1 transition-colors",
        isListening
          ? "animate-pulse text-red-400 hover:text-red-300"
          : "text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300",
        className,
      )}
    >
      <Mic className="h-4 w-4" />
    </button>
  );
}
